import {Link, useParams} from "react-router-dom";
import {GetCategory, GetCategoryArticle} from "./categories.ts";
import {useMemo} from "react";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import useRouteDatalayer from "../../components/useRouteDatalayer.tsx";
import NotFoundPage from "../NotFoundPage.tsx";

export default function HelpArticlePage() {
    const {category_query} = useParams()
    const {article_query} = useParams()

    useRouteDatalayer("hjaelp")

    const categoryAndArticle = useMemo(() => {
        const c = GetCategory(category_query as string)
        if (c === false) {
            return false
        }

        const a = GetCategoryArticle(c, article_query as string)
        if (a === false) {
            return false
        }

        setTitleAndMetaDescription(a.meta_title, a.meta_desc)

        return {
            category: c,
            article: a,
        }
    }, [category_query, article_query])

    if (categoryAndArticle === false) {
        return <NotFoundPage link_back={"/hjaelp"} link_title={"Gå tilbage til hjælp."} />
    }

    return (
        <div className={"page-help-category-article"}>
            <section className="header">
                <div className="content content--nav">
                    <p className="breadcrumb-navigation">
                        <Link to="/hjaelp">Hjælp</Link> <span className="breadcrumb-arrow"/>
                        <Link to={`/hjaelp/${categoryAndArticle.category.link}`}>{categoryAndArticle.category.cat_name}</Link> <span className="breadcrumb-arrow"/>
                    </p>
                    <h1>
                        {categoryAndArticle.article.heading}
                    </h1>
                </div>
            </section>

            <section className="content help-content help-article">
                <categoryAndArticle.article.content/>
            </section>
        </div>
    )
}
